import { render, staticRenderFns } from "./loginOld.vue?vue&type=template&id=5f2d814c&scoped=true"
import script from "./loginOld.js?vue&type=script&lang=js&external"
export * from "./loginOld.js?vue&type=script&lang=js&external"
import style0 from "./loginOld.scss?vue&type=style&index=0&id=5f2d814c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d814c",
  null
  
)

export default component.exports